import { COMPANY } from "@/i18n";

export function FooterContact({ t }) {
  return (
    <div>
      <div className="label-eyebrow text-white/60 mb-3">{t.contact.label}</div>
      <a
        href={`tel:${COMPANY.phoneIntl}`}
        className="inline-block font-bold link-underline py-1.5 mb-1"
        data-testid="footer-phone"
      >
        {COMPANY.phone}
      </a>
      <a
        href={`mailto:${COMPANY.email}`}
        className="block link-underline py-1.5 w-fit"
        data-testid="footer-email"
      >
        {COMPANY.email}
      </a>
    </div>
  );
}

export function FooterArea({ t }) {
  return (
    <div>
      <div className="label-eyebrow text-white/60 mb-3">{t.contact.area}</div>
      <p className="font-bold mb-1">{COMPANY.town}</p>
      <p className="text-white/70 text-sm mb-3">{t.contact.areaValue}</p>
      <a href="/klimatisztitas-balatonszarszo" className="block link-underline text-white/80 text-sm py-1 w-fit" data-testid="footer-city-szarszo">
        Klímatisztítás Balatonszárszó
      </a>
      <a href="/klimatisztitas-balatonlelle" className="block link-underline text-white/80 text-sm py-1 w-fit" data-testid="footer-city-lelle">
        Klímatisztítás Balatonlelle
      </a>
    </div>
  );
}
